import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {

    getCompanyUsers: function (companyId) {
        return axios.get(
            API.url(Endpoints.Companies.Users, {company_id: companyId})
        ).then((res) => {
            return res.data;
        });
    },

    getCompanyUserById: function (companyId, userId) {
        return axios.get(
            API.url(Endpoints.Companies.User, {company_id: companyId, user_id: userId})
        ).then((res) => {
            return res.data.user;
        });
    },

    searchByName: function (query, centreId) {
        return axios.get(
            API.url(Endpoints.Users.SearchByName)
                + ('?query=' + query)
                + (centreId ? ('&centre_id=' + centreId) : '')
        ).then((res) => {
            return res.data.users;
        });
    },

    searchByNameOrCompanyName: function (query, centreId) {
        return axios.get(
            API.url(Endpoints.Users.SearchByNameOrCompanyName)
            + ('?query=' + query)
            + (centreId ? ('&centre_id=' + centreId) : '')
        ).then((res) => {
            return res.data.users;
        });
    },

    searchByField: function (searchByFieldObject, url) {
        Object.keys(searchByFieldObject).forEach(key => searchByFieldObject[key] === undefined ? delete searchByFieldObject[key] : {});

        const qs = new URLSearchParams(searchByFieldObject)

        return axios.get(
            (url ? url : API.url(Endpoints.Users.searchByField)), {
                params: qs
            }
        ).then(res => {
            return res.data;
        });
    },

    getUserById: function (userId) {
        return axios.get(
            API.url(Endpoints.Users.GetUserById + '?id=' + userId)
        ).then((res) => {
            return res.data;
        });
    },

    getUsersByIds: function (usersIds) {
        return axios.post(
            API.url(Endpoints.Users.GetUsersByIds),
            {
                ids: usersIds
            }
        ).then((res) => {
            return res.data;
        });
    }
}
